import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { SUPER_ADMIN } from '../../utils/const/user';

function AuthGuardSuperAdmin({ children }) {
  const account = useSelector((state) => state.account);

  // No se renderiza el contenido mientras se redirige.
  if (account.user.role !== SUPER_ADMIN) {
    window.location.href = '/';
    return null;
  }

  return children;
}

AuthGuardSuperAdmin.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthGuardSuperAdmin;
